import React, { Component, Fragment } from "react";
import TabbedNav from "./tabbedNav";
import Image from "../image/image";

class ProfileList extends Component {
  renderSingleList() {
    const queue = this.props.data.data.find(
      item => item.id === this.props.currentQueue
    );
    const queueData = this.props.config.field_profile_list.find(
      list => list.field_profile_queue === this.props.currentQueue
    );
    const profiles = this.sortProfiles(
      this.filterProfiles(queue.relationships.profiles.data),
      queue.relationships.profiles.data
    );
    const states = this.props.locations.data.map(function(state) {
      return state.attributes.label;
    });

    switch (queueData.field_profile_display) {
      case "location": // By State TODO: Single by location
        return (
          <Fragment>
            {typeof queueData.field_text_1 === "undefined" ? null : (
              <h2>{queueData.field_text_1}</h2>
            )}
            <table>
              <thead>
                <tr>
                  <th>Location</th>
                  <th>Contact</th>
                </tr>
              </thead>
              <tbody>
                {this.props.locations.data.map((state, i) => {
                  const stateProfiles = profiles.filter(function(profile) {
                    // Check for null values, or return match for state
                    return profile.attributes.location === null
                      ? null
                      : profile.attributes.location.find(
                          element => element === state.attributes.label
                        );
                  });
                  // Check for empty states
                  if (stateProfiles.length > 0) {
                    return (
                      <tr key={i}>
                        <td
                          style={{
                            padding: window.innerWidth < 600 ? "4px" : "8px"
                          }}
                        >
                          {state.attributes.label}
                        </td>
                        <td
                          style={{
                            width: "50%",
                            padding: window.innerWidth < 600 ? "4px" : "8px"
                          }}
                        >
                          {stateProfiles.map((profile, i) => {
                            return (
                              <Fragment key={i}>
                                <p
                                  style={{
                                    margin: 0,
                                    fontSize: "16px",
                                    fontWeight: "bold",
                                    lineHeight: "24px"
                                  }}
                                >
                                  {profile.attributes.label}
                                </p>
                                {profile.attributes.title === null ? null : (
                                  <p
                                    style={{
                                      margin: 0,
                                      fontSize: "16px",
                                      lineHeight: "24px"
                                    }}
                                  >
                                    {profile.attributes.title}
                                  </p>
                                )}
                                <p
                                  style={{
                                    margin: 0,
                                    fontSize: "16px",
                                    lineHeight: "24px"
                                  }}
                                >
                                  {profile.attributes.email === null ? null : (
                                    <a
                                      href={
                                        "mailto:" + profile.attributes.email
                                      }
                                    >
                                      {profile.attributes.email}
                                    </a>
                                  )}
                                  {profile.attributes.phone === null ? null : (
                                    <Fragment>
                                      {" "}
                                      or{" "}
                                      <a
                                        href={"tel:" + profile.attributes.phone}
                                      >
                                        {profile.attributes.phone}
                                      </a>
                                    </Fragment>
                                  )}
                                </p>
                              </Fragment>
                            );
                          })}
                        </td>
                      </tr>
                    );
                  } else {
                    // Don't display empty states
                    return null;
                  }
                })}
              </tbody>
            </table>
          </Fragment>
        );
      default:
        // Infoband style
        return (
          <Fragment>
            {typeof queueData.field_text_1 === "undefined" ? null : (
              <h2>{queueData.field_text_1}</h2>
            )}
            {profiles.map((item, i) => (
              <div
                key={i}
                className="infoBand"
                style={{
                  borderBottom: "2px dashed #ccc",
                  float: "left",
                  width: "100%",
                  paddingTop: "1em"
                }}
              >
                {item.attributes.photo === null ? null : (
                  <div style={{ float: "left", padding: "0 3% 1% 0" }}>
                    <Image imageStyle="155" media={item.attributes.photo} />
                  </div>
                )}
                <h3
                  style={{
                    textTransform: "none",
                    fontFamily: "Oswald,sans-serif",
                    color: "#007155"
                  }}
                >
                  {item.attributes.label.replace(/&#039;/g, "'")}
                </h3>
                {item.attributes.title === null ? null : (
                  <p style={{ margin: 0 }}>{item.attributes.title}</p>
                )}
                <p style={{ margin: 0 }}>
                  {item.attributes.email === null ? null : (
                    <a tabIndex="0" href={"mailto:" + item.attributes.email}>
                      {item.attributes.email}
                    </a>
                  )}
                  {item.attributes.phone === null ? null : (
                    <Fragment>
                      {" "}
                      or{" "}
                      <a tabIndex="0" href={"tel:" + item.attributes.phone}>
                        {item.attributes.phone}
                      </a>
                    </Fragment>
                  )}
                </p>
                {item.attributes.location ===
                null ? null : queueData.field_text_1 === "Alphabetical" ? ( // Show all locations
                  <p style={{ margin: 0 }}>
                    {item.attributes.location.join(", ")}
                  </p>
                ) : (
                  <p style={{ margin: 0 }}>
                    {item.attributes.location
                      .filter(
                        // Show only non-state locations
                        function(state) {
                          return states.indexOf(state) === -1;
                        }
                      )
                      .join(", ")}
                  </p>
                )}
              </div>
            ))}
          </Fragment>
        );
    }
  }

  sortProfiles(profiles, queue) {
    // After filtering profiles, sort to proper order
    const newProfiles = [];
    queue.forEach(function(item, i) {
      profiles.forEach(function(profile) {
        if (profile.id === item.id) {
          newProfiles[i] = profile;
        }
      });
    });
    profiles = newProfiles;
    return profiles;
  }

  filterProfiles = queue => {
    return this.props.data.included.filter(function(profile) {
      return queue.find(profiles => profiles.id === profile.id);
    });
  };

  render() {
    switch (this.props.data.data.length) {
      case 1: // Single List
        return <Fragment>{this.renderSingleList()}</Fragment>;
      default:
        // Tabbed list
        return (
          <div>
            <TabbedNav
              activeTab={this.props.currentQueue}
              onTabChange={this.props.onTabChange}
              data={this.props.data.data}
            />
            {this.renderSingleList()}
          </div>
        );
    }
  }
}

export default ProfileList;
